<template>
  <div class="loading">
    <img src="../assets/loading.svg" alt="loading" />
  </div>
</template>

<script>
export default {
  name: "callback",
  props: ["auth"],
  data() {
    this.auth.handleAuthentication();
    return {};
  }
};
</script>

<style>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 800px;
  background-color: white;
}

img {
  width: 100px;
  height: 100px;
}
</style>
